import { render } from "./TabList1.vue?vue&type=template&id=30b7fe35&scoped=true"
import script from "./TabList1.vue?vue&type=script&lang=js"
export * from "./TabList1.vue?vue&type=script&lang=js"

import "./TabList1.vue?vue&type=style&index=0&id=30b7fe35&lang=scss&scoped=true"

import exportComponent from "/data/devops/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30b7fe35"]])

export default __exports__